export const space = {
    x0: '0px',
    x_5: '2px',
    x1: '4px',
    x1_5: '6px',
    x2: '8px',
    x3: '12px',
    x4: '16px',
    x6: '24px',
    x7: '28px',
    x10: '40px',
    x18: '72px',
};
//# sourceMappingURL=spacing.js.map